import React from "react";
import { bonusCoverImages } from "../data/bonusCoverImages";
import { productBrief } from "../data/productBrief";
export function BonusesSection() {
  return <section className="section" id="bonuses" aria-labelledby="bonuses-heading" data-id="element-8" data-mp="gxzw1aavt7tn">
      <div className="shell" data-id="element-9" data-mp="vu7hsf1xuhb1">
        <div className="section-intro" data-id="element-10" data-mp="qtt70p8yct9b">
          <p className="eyebrow" data-id="element-11" data-mp="qsrxip7l4etp">5 INCLUDED BONUSES</p>
          <h2 id="bonuses-heading" data-id="element-12" data-mp="14tkpb26i4vt4">
            Your sessions planned. <span data-id="element-13" data-mp="14rzx3j7ntoyf">The supporting work covered.</span>
          </h2>
          <p data-id="element-14" data-mp="zv9fusk4cnbf">A 10-week calendar, short huddles, skill checks, written reminders and facilitator support — all included.</p>
        </div>
        <ul className="bonus-grid" data-id="element-15" data-mp="1eim62ukvfh85">
          {productBrief.bonuses.map(bonus => <li key={bonus.number} data-id="element-16" data-mp="19kt124vb0t9g">
              <img className="bonus-cover-image" src={bonusCoverImages[bonus.number]} alt={`Cover of ${bonus.title}`} width={640} height={640} loading="lazy" decoding="async" data-id="element-17" data-mp="19mne6x0c3h2z" />
              <div className="bonus-body" data-id="element-18" data-mp="3trxbhcjtq3ip">
                <p className="eyebrow" data-id="element-19" data-mp="3tsylddp3sjyu">BONUS {bonus.number} · INCLUDED</p>
                <h3 data-id="element-20" data-mp="2l2xyf7xn6kq">{bonus.title}</h3>
                <h4 data-id="element-21" data-mp="2k1997xzulkj">{bonus.scopeNote}</h4>
                <p data-id="element-22" data-mp="7kpbyqvl4qul">{bonus.description}</p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
}